import { queryStringify } from '@utils'
import { createMutationHelper } from '@utils/swr'
import { type AccountBindingStatusRequest } from '../../../types/apiRequest'
import { type AccountBindingResponse } from '../../../types/apiResponse'
import { type WpApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<WpApis['get']['accountBindingStatus'], AccountBindingResponse, AccountBindingStatusRequest>({
  client: 'wpRelay',
  key: '/wp-json/lds/api/platform-sdk/account-binding-status',
  fetcher: (url, { arg, client }) => {
    return client.get(`${url}?${queryStringify(arg)}`)
  },
})

export const useRequestAccountBindingStatus = useMutation
